import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AddElementComponent } from 'src/app/AppBaseComponents/add-element/add-element.component';
import { ConfirmDialogModel, DialogComponent } from 'src/app/AppBaseComponents/dialog/dialog.component';
import { NotifyService } from 'src/app/Services/notify.service';
import { ProjectService } from 'src/app/Services/project.service';
import { SharedService } from 'src/app/Services/shared.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SelectiveImportComponent } from 'src/app/AppBaseComponents/selective-import/selective-import.component';
import { CommandStepCopyService } from 'src/app/Services/command-step-copy.service';
import { FeatureAccessService } from 'src/app/Services/feature-access.service';


@Component({
  selector: 'ze-project-view',
  templateUrl: './project-view.component.html',
  styleUrls: ['./project-view.component.scss', '../login-view/login-view.component.scss']
})

export class ProjectViewComponent implements OnInit {
  @ViewChild('multiselect', { static: false }) elementRef: ElementRef<HTMLInputElement>;

  displayValue: string = "";
  error: string = '';
  expand: boolean = false;
  filteredList: any[] = [];
  formGroup: FormGroup;
  jiraColumnList: any[] = [];
  jiraProjectList: any[] = [];
  mappedProject: any = null;

  loading: boolean = false;
  opertaion: any = "";
  projectList: any[] = [];
  shouldShow;
  returnUrl: string;
  selectedProject: any;
  showCreateOption: boolean = false;
  showModal: string = 'selectWebPageOption';
  submitted: boolean = false;
  typeOfOperation: string = "Create";
  updateProject = "";

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private _sharedService: SharedService,
    private notifys: NotifyService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private commandStepCopyService: CommandStepCopyService,
    private featureAccessService: FeatureAccessService
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.shouldShow = "init";
    this.getProjectList();
    localStorage.removeItem('projectId');
    localStorage.removeItem('mapped');
    localStorage.removeItem('isMapped');
    localStorage.removeItem('projectIdDb2');
    localStorage.removeItem('projectName');
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
    this.formGroup.get('name').valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(value => {
      this.getValue(value);
    });
  }

  createForm() {
    this.formGroup = this.fb.group({
      name: ['', Validators.required],
    });
  }

  get formControls() { return this.formGroup.controls; }
  navigateToApp(project) {
    if (!this.selectedProject) {
      this.notifys.notify('warning', 'Warning', "Please select a project first");
      return;
    }
    this._sharedService.loaderHide.emit(true);
    this.featureAccessService.loadProjectAccess(project._id).subscribe(
      () => {
        this.completeNavigation(project);
      },
      () => {
        this.completeNavigation(project);
      }
    );
  }

  private completeNavigation(project) {
    localStorage.setItem('projectId', project._id);
    localStorage.setItem('mapped', project.mapped);
    localStorage.setItem('isMapped', project.isMapped);
    if (project.projectIdDb2 && project.projectIdDb2.$oid) {
      localStorage.setItem('projectIdDb2', project.projectIdDb2.$oid);
    }
    this.projectService.projectName = project.name;
    this.commandStepCopyService.onProjectSwitch(project._id);
    this._sharedService.loaderHide.emit(false);
    if (this.returnUrl) {
      window.location.href = this.returnUrl;
    }
    else {
      this.router.navigate(['/library']);
    }
  }

  buttonClick(typeOfOperation) {
    this.shouldShow = 'FrontFlip';
    typeOfOperation = typeOfOperation;
    if (typeOfOperation == 'Create')
      this.formControls.name.setValue('');
    else
      this.formControls.name.setValue(this.selectedProject.name);
  }

  expandtoggle() {
    if (this.selectedProject) {
      this.expand = !this.expand;
    } else {
      this.selectedProject = null;
      this.expand = false;
    }
  }

  hideList() {
    this.expand = false;
  }
  @HostListener('document:click', ['$event'])
  clickOutside(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.hideList();
    }
  }

  getValue(val: string) {
    this.displayValue = val.trim();
    this.showCreateOption = false;
    let showCreateOptionFlag = false;
    for (let project of this.projectList) {
      if (project.name === this.displayValue) {
        showCreateOptionFlag = true;
        this.selectedProject = project;
        break;
      }
    }
    if (this.displayValue !== '' && !showCreateOptionFlag) {
      this.showCreateOption = true;
      this.selectedProject = null;
    }
    if (showCreateOptionFlag && this.selectedProject && this.displayValue !== this.selectedProject.name) {
      this.selectedProject = null;
    }
    this.filteredList = this.filterList(this.projectList, 'name', this.displayValue);
  }

  filterList(projectList: any[], key: string, value: string) {
    return projectList.filter(project => project[key].toLowerCase().includes(value.toLowerCase()));
  }

  displayobject() {
    this.showModal = 'displaywebobject';
  }

  selectProject(project: any) {
    this.selectedProject = project;
    this.showModal = 'displaywebobject';
    this.expand = true;
    this.getProjectMappingByProjectId();
  }

  openPopUp(data, afterclosecallback) {
    let dialogRef = this.dialog.open(AddElementComponent, {
      data: data
    });
    dialogRef.afterClosed().subscribe(afterclosecallback);
  }

  handleResponseSuccess(data) {
    this.getProjectList();
    this.selectedProject = null;
    this._sharedService.loaderHide.emit(false)
    this.notifys.notify('success', this.opertaion + 'd', `Project ${this.opertaion} Successful`);
    this.opertaion = "";
  }

  handleResponseError(error) {
    this._sharedService.loaderHide.emit(false);
    this.opertaion = "";
  }

  //get project list
  getProjectList() {
    this._sharedService.loaderHide.emit(true)
    this.projectService.getItems().subscribe(data => {
      this.projectList = data.data;
      this.filteredList = JSON.parse(JSON.stringify(this.projectList))
      this._sharedService.loaderHide.emit(false)
    });
  }

  // create project
  createProject() {
    const storedLicenseId = localStorage.getItem('licenseId');
    // Treat explicit "null" or missing value as no license scenario
    const licenseId = storedLicenseId && storedLicenseId !== 'null' ? storedLicenseId : null;
    this.openPopUp({ title: "Create Project", jiratitle: "jiraProject", name: this.displayValue, buttonName: 'Create Project', jiraProjectList: this.jiraProjectList, jiraColumnList: this.jiraColumnList }, (dialogResult => {
      if (dialogResult) {
        this._sharedService.loaderHide.emit(true)
        this.opertaion = "Create"
        this.projectService.createProject(dialogResult.name, licenseId).subscribe(this.handleResponseSuccess.bind(this), this.handleResponseError.bind(this));
      }
    }));
  }

  // modify project 
  modifyProject() {
    if (this.selectedProject) {
      const projectName = this.selectedProject.name;
      this.openPopUp({ title: 'Modify Project', jiratitle: "jiraProject", name: projectName, buttonName: 'Modify Project', jiraProjectList: this.jiraProjectList, jiraColumnList: this.jiraColumnList }, (dialogResult) => {
        if (dialogResult) {
          let data = { project: { _id: this.selectedProject._id, name: dialogResult.name } };
          this._sharedService.loaderHide.emit(true);
          this.opertaion = 'Update';
          this.projectService.updateProject(data).subscribe(
            (data) => {
              this.handleResponseSuccess(data);
            },
            (error) => {
              this.handleResponseError(error);
            }
          );
        } else {
          this.notifys.notify('warning', 'Aborted', 'Update Aborted By User!!!');
        }
      });
    } else {
    }
  }

  // delete project
  deleteProject() {
    const message = `Are you sure you want to delete this?`;
    const dialogData = new ConfirmDialogModel("Delete !!!", message);
    const dialogRef = this.dialog.open(DialogComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        let data = { project: { _id: this.selectedProject._id, name: this.selectedProject.name } };
        this._sharedService.loaderHide.emit(true);
        this.opertaion = "Delete";
        this.projectService.deleteProject(data).subscribe(
          this.handleResponseSuccess.bind(this),
          this.handleResponseError
        );
        this.displayValue = '';
        this.selectedProject = null;
        this.formGroup.controls['name'].setValue('');
      }
      else {
        console.log("Deletion Aborted By User!!!");
        this.notifys.notify('warning', 'Aborted', "Deletion Aborted By User!!!");
      }
    });
  }

  updateSyncProject() {
    const dialogRef = this.dialog.open(SelectiveImportComponent, {
      width: '700px',
      data: {
        projectId: this.selectedProject._id,
        mappedProject: this.mappedProject
      }
    });
  }

  getProjectMappingByProjectId() {
    this.projectService.getProjectMappingByProjectId(this.selectedProject._id).subscribe(
      (res: any) => {
        if (res.operationStatus === 'SUCCESS' && res.data) {
          this.mappedProject = res.data;
        } else {
          this.mappedProject = null;
        }
      },
      (err) => {
        console.error('Error fetching mapping:', err);
        this.mappedProject = null;
      }
    );
  }
}

